module.exports = __webpack_public_path__ + "img/centre-boulevard.7571ab35.jpg";